import { useQuery } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';
import { getEnvAwareValue } from '../../../utils/browser';

export function useGetTerms({ enabled = false }) {
  const query = useQuery({
    enabled,
    queryKey: ['terms-energia-solar'],
    queryFn: async () => {
      const data = await handleFetchResponse(fetch(getApiUrl('/energia-solar/v2/terms')));
      return data;
    },
    retry: (errCount) => errCount < getEnvAwareValue(3, 0) && enabled,
  });

  return query;
}
